<template>
<!--Top page (logo and search button)-->
<div id="top" class="home">
  <div id="header">
    <div id="content_header">
      <router-link :to="{path: '/'}"><div class="sprite logo" style="display:inline-block"></div></router-link>
      <a href="javascript;" @click.prevent="logout()"><div class="search sprite Go_Out" title="Logout" v-if="currentUser"></div></a>
      <cart-icon v-if="currentUser" />
    </div>
  </div>
</div>
<!--Top page Ends-->
</template>

<script>
import CartIcon from './CartIcon.vue'

export default {
  components: {
    CartIcon
  },
  data () {
    return {

    }
  },
  computed: {
    currentUser () {
      return this.$store.state.currentUser
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// StsHeader.vue?2848e4aa